import "./WorkspacePicker.css";
import ReactSelect, { components } from "react-select";
import config from "environment";
import { useSelector } from "react-redux";
import { iconPath } from "winslow-core";
import { selectUser } from "../../redux/features/appData";

const allowNewWorkspace = config.allowNewWorkspace;

// note i use outlines here to hack around some weird CSS layering stuff
const selectStyles = {
  control: (baseStyles, state) => ({
    // backgroundColor: "var(--background-color-primary)",
    backgroundColor: "var(--workspace-background-color)",
    height: "40px",
    width: "100%",
    alignItems: "center",
    // outline: "var(--border-secondary)",
    outline: "none",
    borderRadius: "var(--border-radius)",
    margin: "0px",
    display: "flex",
  }),
  valueContainer: (baseStyles, state) => ({
    display: "flex",
    // backgroundColor: "var(--background-color-primary)",
    backgroundColor: "var(--workspace-background-color)",
    padding: "0px",
    margin: "0px",
    // color: "#FFF",
    color: "var(--text-color-primary)",
    fontSize: "14px",
    fontWeight: "800",
  }),
  singleValue: (baseStyles, state) => ({
    padding: "0px",
    borderRadius: "var(--border-radius)",
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: "var(--background-color-primary)",
    borderRadius: "var(--border-radius)",
    outlineColor: "var(--menu-background-color-primary)",
    padding: "0px",
    marginTop: "8px",
  }),
  menuList: (baseStyles, state) => ({
    backgroundColor: "var(--background-color-primary)",
    padding: "0px",
    borderRadius: "var(--border-radius)",
  }),
  option: (baseStyles, state) => ({
    backgroundColor: state.isFocused
      ? "var(--menu-background-color-selected)"
      : "var(--menu-background-color-primary)",
    border: "1px solid none",
  }),
};

export default function WorkspacePicker({
  workspaces,
  selectedId,
  onChangeCallback,
}) {
  const storeUser = useSelector(selectUser);

  const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={iconPath("switch.svg", storeUser)} />
      </components.DropdownIndicator>
    );
  };

  const pickerOptions = {
    IndicatorSeparator: () => null,
    DropdownIndicator: CustomDropdownIndicator,
  };

  let options = [];

  const workspacesCopy = [...workspaces];

  if (workspaces) {
    workspacesCopy.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );

    options = workspacesCopy.map((workspace, index) => {
      return {
        value: workspace.id,
        label: workspace.name,
        image: workspace.image,
        isSelected: false,
      };
    });
  }

  if (allowNewWorkspace) {
    // add the one to add
    options.push({
      value: "__new",
      label: "(add new workspace)",
      image: "/icons/add_workspace.png",
      isSelected: false,
    });
  }

  const defaultValue = workspacesCopy.findIndex(
    (workspace) => workspace.id === selectedId
  );

  const handleInputChange = (input, action) => {
    onChangeCallback(input.value);
  };

  return (
    <>
      <div className="workspace-picker-container">
        <ReactSelect
          styles={selectStyles}
          options={options}
          value={options[defaultValue]}
          components={pickerOptions}
          isSearchable={false}
          onChange={handleInputChange}
          formatOptionLabel={(option) => (
            <div className="workspace-picker-option">
              {option.value === "__new" && (
                <div className="workspace-picker-image">
                  <img
                    src={option.image}
                    style={{ height: "16px", width: "16px" }}
                    alt="workspace-image"
                  />
                </div>
              )}
              <div className="workspace-picker-name">{option.label}</div>
              {/* <div className="workspace-picker-unfold">
                            {option.isSelected ? <img className="icon-green-check"/> : <div style={{width: "24px"}}>&nbsp;</div>}
                        </div> */}
            </div>
          )}
        />
      </div>
    </>
  );
}
